__turbopack_context__.v({
  "app_light_theme": "Phone-module-scss-module__fHTcGa__app_light_theme",
  "button": "Phone-module-scss-module__fHTcGa__button",
  "captcha": "Phone-module-scss-module__fHTcGa__captcha",
  "countdown": "Phone-module-scss-module__fHTcGa__countdown",
  "input": "Phone-module-scss-module__fHTcGa__input",
  "rights": "Phone-module-scss-module__fHTcGa__rights",
  "root": "Phone-module-scss-module__fHTcGa__root",
  "subtitle": "Phone-module-scss-module__fHTcGa__subtitle",
  "title": "Phone-module-scss-module__fHTcGa__title",
});
